import ServiceChargeSettings from './ServiceChargeSettings';

export default ServiceChargeSettings;
